import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { SITE_CONFIG } from "../constants/data";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  // Start with the static SITE_CONFIG so the site renders instantly;
  // swap in live values from the database as soon as they arrive.
  const [settings, setSettings] = useState({
    established: SITE_CONFIG.established,
    brandName: SITE_CONFIG.brandName,
    tagline: SITE_CONFIG.tagline,
    slogan: SITE_CONFIG.slogan,
    location: SITE_CONFIG.location,
    whatsapp: SITE_CONFIG.whatsapp,
    whatsappDisplay: SITE_CONFIG.whatsappDisplay,
    instagram: SITE_CONFIG.instagram,
    facebook: SITE_CONFIG.facebook,
    deliveryFee: 200,
    freeDeliveryAbove: 0,
  });

  useEffect(() => {
    let active = true;
    api
      .getSettings()
      .then((s) => {
        if (active && s) setSettings((prev) => ({ ...prev, ...s }));
      })
      .catch(() => {
        // Keep the static fallback values if the API isn't reachable yet
        // (e.g. MONGODB_URI not configured).
      });
    return () => {
      active = false;
    };
  }, []);

  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
}

export function useSettings() {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error("useSettings must be used within a SettingsProvider");
  return ctx;
}
